import React, { useRef, useState } from 'react';
import { TouchableOpacity, View, FlatList } from 'react-native';
import { Typography, Icons, PositionModal } from '@hmsexp/component-library';
import { styles } from '../style';
import isArray from 'lodash/isArray';

const ActionPopover = ({ actionMenuData = [], onItemClick }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [popupPosition, setPopupPosition] = useState(null);

  const compRef = useRef(null);
  const updateParentPosition = () => {
    if (compRef?.current && typeof compRef.current.measure === 'function') {
      compRef.current.measure((fx, fy, width, height, px, py) => {
        setPopupPosition({ x: px, y: py + 8, w: width, h: height });
      });
    }
  };

  const handleItemClick = item => {
    onItemClick?.(item);
    setIsVisible(false);
  };

  const renderMenuItem = subItem => (
    <TouchableOpacity style={styles.menuItem} activeOpacity={0.6} onPress={() => handleItemClick(subItem)}>
      <Typography fontWeightType='regular'>{subItem.label}</Typography>
    </TouchableOpacity>
  );

  const renderItem = ({ item, index }) => {
    const isGrouped = isArray(item?.items);

    return (
      <View
        style={[styles.actionPopoverItemContainer, index === actionMenuData?.length - 1 && { borderBottomWidth: 0 }]}>
        {isGrouped ? (
          <>
            <View style={styles.actionPopupGroupitem}>
              {item.icon && <View>{item.icon}</View>}
              <Typography style={styles.groupTitle}>{item.title}</Typography>
            </View>
            <FlatList
              style={styles.actionPopoverItemsContainer}
              data={item.items}
              keyExtractor={subItem => subItem.label}
              renderItem={({ item: subItem }) => renderMenuItem(subItem)}
              ItemSeparatorComponent={() => <View style={{ height: 4 }} />}
            />
          </>
        ) : (
          renderMenuItem(item)
        )}
      </View>
    );
  };

  return (
    <View ref={compRef} onLayout={updateParentPosition}>
      <TouchableOpacity
        onPress={() => {
          setIsVisible(true);
          updateParentPosition();
        }}>
        <Icons.TripleDots size='XL' />
      </TouchableOpacity>

      <PositionModal visible={isVisible} outsideClick={() => setIsVisible(false)} parentPositions={popupPosition}>
        <View style={styles.actionPopoverModalContainer}>
          <FlatList
            data={actionMenuData}
            renderItem={renderItem}
            keyExtractor={(item, i) => item.title || item.label || `${i}`}
          />
        </View>
      </PositionModal>
    </View>
  );
};

export default ActionPopover;
